module.exports = "/assets/12bc19be84d4f1042a6a421c4bd0a1d2.png";